import { PhaserGamePad } from "src/games/shared/Gamepad";
import bindAllOfThis from "src/utils/BindThisHelper";
import { EventScene } from "./EventScene";

export class UpdateScene extends Phaser.Scene {
    private initialized: boolean = false;
    private player: Phaser.Physics.Arcade.Image;
    private speed: number = 100;
    private generalSize: number = 64;
    private gamePad: PhaserGamePad;
    private xVel: number = 0;
    private yVel: number = 0;

    constructor() {
        super({
            key: "UpdateScene"
        });
    }

    init(data: any) {
        console.warn("Running Init", UpdateScene.name, data); // JB - Remove this console.warn
        if (data != null && this.initialized) {
            this.player.setPosition(data.x, data.y);
        }
    }

    preload(): void {
        this.load.image("player", require("/src/assets/games/coinRunner/player.png"));

        PhaserGamePad.preload(this);
    }

    create(): void {
        if (this.initialized) {
            return;
        }
        bindAllOfThis(this, UpdateScene.prototype);

        this.input.addPointer(6);
        this.gamePad = new PhaserGamePad(this);

        this.createObjects();
        this.initialized = true;
    }

    createObjects() {
        let blackground = this.add.image(0, 0, "background")
            .setOrigin(0)
            .setTint(0xffddff);
        let overlay = this.add.text(16, 16, "This demo uses an update loop approach to moving the player around", {
            fontSize: '24px',
            fill: '#ffffff'
        });
        let switcherButton = this.add.image(this.sys.canvas.width - 128 - 16, 16, "pixel");
        switcherButton.setTint(0x003355);
        switcherButton.setDisplaySize(128, 64);
        switcherButton.setInteractive();
        switcherButton.setDepth(2);
        switcherButton.on("pointerdown", () => {
            this.scene.remove(this);
            this.scene.add("EventScene", EventScene, true);
            // this.scene.switch(EventScene.name);
            // this.scene.run(EventScene.name, new Phaser.Geom.Rectangle(this.player.x, this.player.y));
            // this.scene.pause(UpdateScene.name);
        });
        let buttonText = this.add.text(switcherButton.x, switcherButton.y, "Flip!", {
            fontSize: '16px',
            fill: '#ffffff'
        });
        buttonText.setDepth(2);
        Phaser.Display.Align.In.Center(buttonText, switcherButton);

        this.player = this.physics.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "player");
        this.player.setOrigin(.5);
        this.player.setDisplaySize(this.generalSize, this.generalSize);
    }

    update(): void {
        console.log('using update scene');
        // Local reference not needed, but its like 4 properties in and tidies up the code nicely
        let keys = this.gamePad.keys;
        let scale: number = 1;

        // Zero out the velocities
        this.xVel = 0;
        this.yVel = 0;

        if (keys.up.isDown) {
            this.yVel += -this.speed;
        }
        // Note: If you do an `else if` you will only ever be able to use one button
        if (keys.down.isDown) {
            this.yVel += this.speed;
        }
        if (keys.left.isDown) {
            this.xVel += -this.speed;
        }
        if (keys.right.isDown) {
            this.xVel += this.speed;
        }

        // Check scaling
        if (keys.a.isDown) {
            scale *= .5;
        }
        if (keys.b.isDown) {
            scale *= 3;
        }

        this.player.setDisplaySize(this.generalSize * scale, this.generalSize * scale);
        this.player.setVelocity(this.xVel * scale, this.yVel * scale);

        // Check the flip
        if (this.xVel !== 0 && (this.gamePad.keys.left.isDown || this.gamePad.keys.right.isDown)) {
            this.player.setFlipX(this.xVel < 0);
        }
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserGamePadDemo/scenes/UpdateScene.ts